/**
 * App Builder Commands
 * 
 * Commands for AI-powered app generation and iteration.
 */

export { appBuilderCreateCommand } from './app_builder_create';
export { appBuilderPublishCommand } from './app_builder_publish';
export { appBuilderUpdateCommand } from './app_builder_update';
export { websiteCreateCommand } from './website_create';

import { appBuilderCreateCommand } from './app_builder_create';
import { appBuilderPublishCommand } from './app_builder_publish';
import { appBuilderUpdateCommand } from './app_builder_update';
import { websiteCreateCommand } from './website_create';
import { SelfContainedCommand } from '../../../types/commands';

export const appBuilderCommands: SelfContainedCommand[] = [
  appBuilderCreateCommand,
  appBuilderPublishCommand,
  appBuilderUpdateCommand,
  websiteCreateCommand,
];
